import React, { useEffect, useState } from "react";
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import PersonSearchTwoToneIcon from '@mui/icons-material/PersonSearchTwoTone';
import SelectPersonaModal, {SelectPersonaParentezcoModal} from "./PersonaModal";
import {ChurchTwoTone} from "@mui/icons-material";
import {InputAdornment} from "@mui/material";


export default function PersonaButton (params){
  const { nombre, Label}=params
  const [openPersona, setOpenPais]=useState(false)
  const [selectedPerson, setSelectedPerson]=useState(0)
  const [namePerson, setNamePerson]= useState()

  useEffect(()=>{
      setSelectedPerson(params.row[nombre])
      setNamePerson(params.row[Label])
  },[selectedPerson])
    
  const handleOpenPais=(name)=>{
    setOpenPais(true)
    params.row.openPersona=true
  }
  
  const handleClosePersona=(nombrecompleto, id)=>{
    if(id){
      params.row[nombre]=id
      params.row[Label]=nombrecompleto
      setNamePerson(nombrecompleto)
      setSelectedPerson(id)
    }
    setOpenPais(false)
  }
  
  return (
    <React.Fragment>
      <div className="cellAction">
        <SelectPersonaModal openPersona={openPersona} handleClosePais={handleClosePersona}></SelectPersonaModal>
        {params.row.edit?null:<IconButton aria-label="delete" size="large" onClick={()=>handleOpenPais("field.name")}>
          <PersonSearchTwoToneIcon value={"field.name"} fontSize="inherit" />
        </IconButton>}
        {namePerson}
      </div>
    </React.Fragment>  
  );
}


  export function PersonaButtonforForms (props){
    const { value, value_name, Label, label_name, handleChange, title, setDataResponse, setCatchResponse}=props
    const [openPersona, setOpenPais]=useState(false)
    const [selectedPerson, setSelectedPerson]=useState(0)
    const [namePerson, setNamePerson]= useState('')

    useEffect(()=>{
        setSelectedPerson(value)
        setNamePerson(Label)
        
    },[selectedPerson, value])
    
    const handleOpenPais=()=>{
      setOpenPais(true)
    }
  
    const handleClosePersona=(nombrecompleto, id)=>{
      if(id){
        handleChange(id, value_name, nombrecompleto, label_name)
        setNamePerson(nombrecompleto)
        setSelectedPerson(id)
      }
      setOpenPais(false)
    }
  
    return (
      <React.Fragment>
        <div className="cellAction" style={{display:'flex', width:'100%'}} >
          <SelectPersonaModal setDataResponse={setDataResponse} setCatchResponse={setCatchResponse} openPersona={openPersona} handleClosePais={handleClosePersona}></SelectPersonaModal>
          {<IconButton aria-label="delete" size="large" onClick={handleOpenPais}>
            <PersonSearchTwoToneIcon value={"field.name"} fontSize="inherit" />
          </IconButton>}
          <TextField
            label={title}
            multiline
            variant="standard"
            maxRows={1}
            margin="normal"
            fullWidth
            value={namePerson||''}

          />
          
        </div>
      </React.Fragment>  
    );
  }
export function PersonaEmergenciaButtonforForms (props){
  const { value, value_name, Label, label_name, parentezco: extra, estado, handleChange, title, setDataResponse, setCatchResponse}=props
  const [openPersona, setOpenPais]=useState(false)
  const [selectedPerson, setSelectedPerson]=useState(0)
  const [namePerson, setNamePerson]= useState('')
  const [parentezco, setParentezco]=useState('')
  const [fallecido, setFallecido]=useState(false)
  useEffect(()=>{
    setSelectedPerson(value)
    setNamePerson(Label)
    setParentezco(extra);
    setFallecido(estado);
  },[selectedPerson, value])

  const handleOpenPais=()=>{
    setOpenPais(true)
  }

  const handleClosePersona=(nombrecompleto, id, parentezco, fallecido)=>{
    if(id){
      handleChange(id, value_name, nombrecompleto, label_name, [
          {name: `parentezco_${label_name}`, value: parentezco},
          {name: `fallecido_${label_name}`, value: fallecido},
      ])
      setNamePerson(nombrecompleto)
      setSelectedPerson(id)
      setParentezco(parentezco)
      setFallecido(fallecido)
    }
    setOpenPais(false)
  }

  return (<React.Fragment><div className="cellAction" style={{display:'flex', width:'100%'}} >
        <SelectPersonaParentezcoModal setDataResponse={setDataResponse} setCatchResponse={setCatchResponse} openPersona={openPersona} handleClosePais={handleClosePersona} handleSelectPersona={true}></SelectPersonaParentezcoModal>
        {<IconButton aria-label="delete" size="large" onClick={handleOpenPais}>
          <PersonSearchTwoToneIcon value={"field.name"} fontSize="inherit" />
        </IconButton>}
        <TextField
            label={title} multiline variant="standard" maxRows={1} margin="normal" fullWidth
            value={`${namePerson} ${parentezco ? `(${parentezco})` : ''}`}
            InputProps={fallecido ? {
              startAdornment: (
                  <InputAdornment position="start">
                    <ChurchTwoTone />
                  </InputAdornment>
              )
            } : undefined}
        />
  </div>
  </React.Fragment>
  );
}